import * as types from './types'
import http from '../../utils/http'
import router from '../../router/index'
import { Loading } from 'element-ui'
import Vue from 'vue'

const vue = new Vue()
// 处理最后一级数组为null
function processTree (data) {
  for (let i = 0; i < data.length; i++) {
    if (data[i].children.length < 1) {
      // children长度小于1, 将children置为null
      data[i].children = null
    } else {
      // 否则继续进入循环
      processTree(data[i].children)
    }
  }
  // 最后处理完的数据
  return data
}
const state = {
  login: {},
  schoolList: [],
  dataCenterPermis: [], // 数据中心平台权限
  userinfo: {
    menuList: null
  },
  logout: {},
  regionList: [],
  FullScreenShow: true,
  menuList: {},
  // 标签
  tagsMark: 0,
  tagPush: null,
  tagName: ''
}

const actions = {
  // 登录
  [types.LOGIN] (context, params) {
    http.fetch('/api/user/login', params).then(data => {
      // console.log(params)
      localStorage.setItem('accout', params.accout)
      localStorage.setItem('password', params.password)
      context.commit(types.LOGIN, data)
    })
  },
  [types.GETINFO] (context, params) {
    http.fetch('/api/user/getUserInfo', params).then(data => {
      context.commit(types.GETINFO, data)
    })
  },
  // 退出登录
  [types.LOGOUT] (context, params) {
    http.fetch('/api/user/logOut', params)
    context.dispatch('tagsView/delAllViews')
    context.commit(types.LOGOUT)
  },
  // 查询所有的省市区数据
  [types.GETREGION] (context, params) {
    http.fetch('/api/region/getRegion', params).then(data => {
      context.commit(types.GETREGION, data)
    })
  },
  // 标签
  [types.CLOSECURRENTTAG] (context, params) {
    context.commit(types.CLOSECURRENTTAG, params)
  },
  [types.SETDATACENTERPERMIS] (context, data) {
    context.commit(types.SETDATACENTERPERMIS, data)
  }
}

const mutations = {
  // 登录
  [types.LOGIN] (state, data) {
    state.login = data
    if (data.code === 200) {
      setTimeout(function () {
        // 遮罩层
        Loading.service({
          fullscreen: true,
          background: '#fff',
          text: '数据加载中，请稍候',
          spinner: 'el-icon-loading'
        })
      }, 1000)
      setTimeout(() => {
        // 跳转
        router.push('/')
      }, 1250)
      vue.$message({
        showClose: true,
        message: '登录成功',
        type: 'info'
      })
    } else {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'error'
      })
      return false
    }
    localStorage.setItem('token', data.obj.tokenKey)
    localStorage.setItem('identity', data.obj.identity)
    localStorage.setItem('supplierCode', data.obj.user.supplierCode)
    localStorage.setItem('warehouseCode', data.obj.warehouseCode)
    localStorage.setItem('warehouseCodes', JSON.stringify(data.obj.warehouseCodes || ''))
    localStorage.setItem('isLmOpen', data.obj.isLmOpen)
    localStorage.setItem('isMdOpen', data.obj.isMdOpen)
    // state.userinfo = data.obj
    // state.userinfo.menuList = processTree(data.obj.menuList)
    // console.log(state.userinfo.menuList, '登陆')
  },
  [types.GETINFO] (state, data) {
    // data.obj.menuList = processTree(data.obj.menuList)
    state.userinfo.isLmOpen = data.obj.isLmOpen
    state.userinfo.isMdOpen = data.obj.isMdOpen
  },
  [types.LOGOUT] (state, data) {
    state.userinfo = {
      menuList: null
    }
    localStorage.removeItem('token')
    router.push('/login')
  },
  // 查询所有的省市区数据
  [types.GETREGION] (state, data) {
    state.regionList = processTree(data.obj)
  },
  // 标签
  [types.CLOSECURRENTTAG] (state, data) {
    state.tagsMark = 1
    // eslint-disable-next-line valid-typeof
    if (typeof (data) === 'object') {
      state.tagPush = data.path
      state.tagName = data.name
    } else {
      state.tagPush = data
    }
  },
  [types.SETDATACENTERPERMIS] (state, data) {
    state.dataCenterPermis = data
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/user/index.js